<wl-progress [hidden]="isDataPending"></wl-progress>

<app-spinner-overlay [showSpinner]="loading"></app-spinner-overlay>
<wl-card heading="MIS" subheading1="{{subheading1}}" subheading2="{{subheading2}}">
  <mat-card
    class="h-500px flex flex-column flex-between bg-shadow-none">

    <form [formGroup]="misForm">
      <table class="w-52rem mx-auto">
        <tr *ngIf="isCO">
          <td class="text-left">
            <mat-form-field appearance="outline" class="w-full-important">
              <mat-select placeholder="Select State" class="w-full" [(ngModel)]="selectedState"
                formControlName="state" (ngModelChange)="selectState()">
                <mat-option *ngFor="let state of states" [value]="state.code">{{state.name}}</mat-option>
              </mat-select>
            </mat-form-field>
          </td>
        </tr>
        <tr *ngIf="showTypeNCodeSelection">
          <td class="text-left">
            <mat-form-field appearance="outline" class="w-full-important">
              <mat-select class="font-size-17px mb-1rem" placeholder="Select Organisation Level"
                (selectionChange)="accessSelected($event.value)" formControlName="organisationName"
                [disabled]="!isOrgLevelEnabled">
                <mat-option *ngFor="let opt of accessName" [value]="opt.value">{{opt.name}}</mat-option>
              </mat-select>
            </mat-form-field>

          </td>

        </tr>
        <tr *ngIf="hideZrbListDropDown">
          <td>
            <div class="h-2rem"></div>
          </td>
        </tr>
        <tr *ngIf="showTypeNCodeSelection && !hideZrbListDropDown">
          <td class="text-left">
            <div class="w-full">
              <wl-autocomplete-nolabel class="mt-20px" label="" placeholder="{{codePlaceholder}}"
                formControlName="code" [options]="options" (selected)="ZRBSelected($event)"
                [disabled]="disableCodeDropdown">
              </wl-autocomplete-nolabel>
            </div>

          </td>
        </tr>
        <!-- <tr *ngIf="showTypeNCodeSelection && isCO">
          <td class="text-left">
            <div class="w-full">
              <mat-form-field class="w-full">
                <input formControlName="code" matInput type="text" placeholder="Office Name" [readonly]=true [value]="Central Office">
              </mat-form-field>
            </div>

          </td>
        </tr> -->
        <tr>
          <td class="text-left">
            <mat-form-field appearance="outline" class="w-full-important">
              <mat-select class="font-size-17px text-left" placeholder="Type of MIS" formControlName="misTypes"
                *ngIf="showDropDown" [disabled]="!isMisTypeEnabled">
                <mat-option *ngFor="let opt of misTypes" [value]="opt">{{opt}}</mat-option>
              </mat-select>
            </mat-form-field>

          </td>
        </tr>
      </table>
      <br><br>
      <div class="text-center">
        <table class="w-full mis-date-row">
          <!-- <tr>
            <td class="text-center" colspan="2">
              <b class="font-size-17px text-right">Date Range:</b>
            </td>
          </tr> -->
          <tr>
            <!-- <td width="10%">
              <b class="font-size-17px text-right">Date Range:</b>
            </td> -->
            <td class="text-right" width="44%">
              <label class="mr-2"><span><b>Date
                    Range:&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</b></span>From &nbsp;
                <input type="date" id="start" name="start" min="2022-01-01"
                  [max]="misForm.get('date2').value || maxDate" formControlName="date1"
                  #date1 class="date-input-styled"></label>
            </td>

            <td class="text-left" width="37%">
              <label class="ml-2">&nbsp; To &nbsp;
                <input type="date" id="end" name="end" [min]="misForm.get('date1').value || '2022-01-01'"
                  [max]="maxDate" formControlName="date2"
                  #date1 class="date-input-styled"></label>
            </td>
          </tr>
          <tr>
            <td colspan="2" class="text-center">
              <span *ngIf="isDateRangeInvalid()" class="text-d32f2f font-size-13px">
                From date cannot be greater than To date
              </span>
              <span *ngIf="isFutureOrOutOfRangeDateInvalid()" class="text-d32f2f font-size-13px">
                Future dates are not allowed
              </span>
            </td>
          </tr>
          <tr>
            <td height="40px" colspan="2"></td>
          </tr>
          <tr>
            <!-- <td width="22.3%"> -->
            <!-- <b class="font-size-17px text-right">Date Range:</b> -->
            <!-- </td> -->
            <td colspan="2" class="text-center">
              <!-- <button class="button" (click)="runReport(misForm.value)" [disabled]="misForm.invalid">Run Report</button> -->
              <button class="mybutton ml-45px" (click)="runReport(misForm.value)"
                [disabled]="misForm.invalid">Download Excel</button>
              <!-- {{misForm.controls['code'].valid}} -->
              <button class="mybutton ml-50px" (click)="resetForm()">Reset</button>


            </td>

          </tr>
        </table>
      </div>
    </form>

  </mat-card>
</wl-card>

<!-- <button (click)="test()"></button> -->




<!-- <link rel="stylesheet" href="../../../assets/bootstrap-grid.css"> -->
<link rel="stylesheet" href="https://pro.fontawesome.com/releases/v5.10.0/css/all.css"
  integrity="sha384-AYmEC3Yw5cVb3ZcuHtOA93w35dYTsvhLPVnYs9eStHfGJvOvKxVfELGroGkvsg+p" crossorigin="anonymous" />
<!-- <link rel="stylesheet" href="https://maxcdn.bootstrapcdn.com/bootstrap/3.3.7/css/bootstrap.min.css"> -->
